import styled from "styled-components";

export const AddVisitorContainer = styled.div`
  padding: 0 20px;
`;
